{
  "#PRODUKTIONSAUFTRAG": {
    "TITLE": "Produktionsauftrag",
    "COMPONENTS": {
      "FILTER": {
        "EXTENDED_FILTER": "Weitere Filter",
        "STANDARD_FILTER": "Weniger Filter",
        "QUERY": "Aufträge suchen"
      }
    },
    "PAGES": {
      "LIST": {
        "TITLE": "Produktionsaufträge",
        "PRODUKTIONSAUFTRAG": "PR-Auftrag",
        "CHARGE": "Charge",
        "ARTIKEL_NR": "Artikel-Nr.",
        "ARTIKEL_BEZEICHNUNG": "Artikel Bezeichnung",
        "AMOUNT": "Menge + EH",
        "KUNDE_NR": "Kunde-Nr.",
        "KUNDE_BEZEICHNUNG": "Kunde Bezeichnung",
        "ZEILENVERMERK": "Zeilenvermerk",
        "LINIE": "Linie",
        "PRODUKTIONSDATUM": "Produktionsdatum",
        "STATUS": {
          "HEADER": "Status",
          "O": "Offen",
          "L": "LLR",
          "V": "Vorbereitet",
          "P": "Produktion",
          "E": "Erledigt",
          "A": "Abgebrochen",
          "F": "Fertig"
        },
        "LIEFERDATUM": "Lieferdatum"
      },
      "DETAIL": {
        "TITLE": "Produktionsauftrag - {{nummer}} {{artbez}}",
        "RHD": "Tage Mindesthaltbarkeit",
        "STUECKELUNG": "Stückelung",
        "CHARGE": "Charge",
        "PLU": "PLU",
        "KUNDE": "Kunde",
        "ARTIKEL": "Artikel",
        "FERTIGUNGSPFAD": "Fertigungspfad",
        "GEWICHT": "Gewicht",
        "VEJEPAL": "VE / PAL",
        "VEJELAGE": "VE / Lage",
        "STUECKJEEVE": "Stück / EVE",
        "EVEJEVE": "EVE / VE",
        "LAGEN": "Lagen",
        "STATUS": "Status",
        "AUFTRAG": {
          "TITLE": "Auftrag",
          "NUMMER": "Nummer",
          "AUFTRAGSDATUM": "Auftragsdatum",
          "STATUS": {
            "LABEL": "Status",
            "O": "Offen",
            "E": "Erledigt",
            "L": "Im LLR",
            "T": "Teilweise erledigt"
          },
          "MENGE": "Menge",
          "PROD_DATUM": "Prod.-Datum",
          "LINIE": "Linie"
        },
        "ZEILENTEXT": "Zeilentext",
        "ARTIKELINFORMATION": "Artikelinformation",
        "INTERNE_ANFORDERUNGEN": {
          "HEADER": "Interne Anforderungen",
          "ANFORDERUNG": "Anforderung",
          "KUNDEN_SPEZIFISCHE_ANFORDERUNGEN": "Kundenspezifische Anforderungen",
          "MASCHINEN_PARAMETER": "Maschinenparameter"
        },
        "REZEPTUREN": {
          "HEADER": "Rezepturen",
          "OVERLINE": "Rezept: ",
          "SOLL_MENGE": "Soll-Menge",
          "RESERVIERTE_MENGE": "Res.-Menge",
          "SCAN_MENGE": "Gescannte-Menge",
          "ARTIKELINFO": "Artikelinfo",
          "KOMPONENTEN_VERWIEGUNG": "Komponentenverwiegung",
          "GANZCHARGENMENGE": "Ganzchargenmenge ({{anzahlGanzcharge}})",
          "TEILCHARGENMENGE": "Teilchargenmenge ({{anzahlTeilcharge}})",
          "CHARGENGROESSE": "Chargengröße: "
        },
        "VERARBEITUNGSSCHRITTE": {
          "HEADER": "Verarbeitungsschritte",
          "SCHRITT": "Schritt",
          "TAETIGKEIT": "Tätigkeit"
        }
      }
    },
    "MESSAGES": {
      "NO_DATA": "Zu Ihren Kriterien wurden keine Produktionsaufträge gefunden"
    }
  }
}
